import { Box, Modal } from 'app/components/design-system-components'
import AIAnalyzerHeader from 'app/components/display/smartdocs/AIAnalyzerHeader'
import Explainer, { DataType } from 'app/components/display/smartdocs/explainer'
import { getTotalAndCheckItemNumber } from 'app/components/display/smartdocs/helpers'

function CorrectDocumentModal({
  toggleModal = () => {},
  analysisResult,
  isCopilot = false,
  onClickConfirmOKForAnalysis = () => {},
  onClickUndoForAnalysis = () => {},
  modalType = 'Payslip',
  isRenterSide = true,
}: {
  toggleModal: () => void
  analysisResult: DataType
  isCopilot: boolean
  onClickConfirmOKForAnalysis: () => void
  onClickUndoForAnalysis: () => void
  modalType?: string
  isRenterSide?: boolean
}) {
  const allData = Object.values(analysisResult.analysis).flat()
  const { totalDocNumber, docNumberToCheck } =
    getTotalAndCheckItemNumber(allData)

  const modalBody = (
    <Box width="100%" lineHeight="140%">
      <Box mt={3} mb={5}>
        It looks like this {modalType} might not match any of your employment
        details. Please confirm the details are correct?
      </Box>
      <AIAnalyzerHeader
        isCopilot={isCopilot}
        withLearnMore={true}
        checkedItem={totalDocNumber}
        foundItems={docNumberToCheck}
      />
      <Box mt={4}>
        <Explainer
          data={analysisResult}
          isCopilot={isCopilot}
          isRenterSide={isRenterSide}
          onClickConfirmOKForAnalysis={onClickConfirmOKForAnalysis}
          onClickUndoForAnalysis={onClickUndoForAnalysis}
        />
      </Box>
    </Box>
  )
  return (
    <Modal
      modalHeading="Correct Document?"
      modalBody={modalBody}
      modalFooter={undefined}
      primaryLabel="Continue"
      primaryAction={toggleModal}
      secondaryLabel="Close"
      secondaryAction={toggleModal}
      toggleModal={toggleModal}
    />
  )
}

export default CorrectDocumentModal
